<style>
@import '../../custom/css/cotacao.css';
</style>

<template>
  <div class="cotacao" v-if="!checkIsEmpty(cotacao)">
    <div class="row m-0">
      <div class="col-12">
        <h1 class="title font-weight-bold text-uppercase">
          Orçamento Solicitado
        </h1>
        <hr class="linha-amarela" />
      </div>
      <div class="col-12">
        <div class="card-cotacao">
          <div class="cc-header d-flex">
            <div class="cc-sub-title m-r-25">
              <img
                class="imagem-archive-cotacao"
                src="@/assets/img/icons/file-archive.png"
                alt="Ícone para representar a cotação"
              />
            </div>
            <div class="cc-sub-title d-flex align-items-center">
              <div v-if="cotacao[0].nome_cotacao !== null">
                Nome:
                <div class="cc-sub-result">{{ cotacao[0].nome_cotacao }}</div>
              </div>
            </div>
            <div class="cc-sub-line"></div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Data:
                <div class="cc-sub-result" v-if="cotacao[0].criado_em !== null">
                  {{ cotacao[0].criado_em }}
                </div>
              </div>
            </div>
            <!-- <div class="cc-sub-line"></div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Cód:
                <div class="cc-sub-result" v-if="cotacao[0].id !== null">{{ cotacao[0].id }}</div>
              </div>
            </div> -->
            <div class="cc-sub-line"></div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Preferência:
                <div class="cc-sub-result" v-if="preferencia !== null">
                  {{ preferencia }}
                </div>
              </div>
            </div>
          </div>
          <div class="cc-content p-0">
            <div class="table-responsive">
              <table class="table table-pedidos" v-if="produtos.length > 0">
                <thead>
                  <tr class="tr">
                    <th class="th">Item</th>
                    <th class="th">Nome</th>
                    <th class="th">Marca</th>
                    <th class="th">Quantidade</th>
                    <th class="th">Medida</th>
                    <th class="th">Foto</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="tr"
                    v-for="(produto, index) in produtos"
                    :key="index"
                  >
                    <td class="td">{{ index + 1 }}</td>
                    <td class="td" v-if="produto.produto !== null">
                      {{ produto.produto.nome }}
                    </td>
                    <td class="td" v-else-if="produto.produto_nome !== null">
                      {{ produto.produto_nome }}
                    </td>
                    <td class="td" v-else>Sem Produto</td>
                    <td class="td" v-if="produto.marca !== null">
                      {{ produto.marca.nome }}
                    </td>
                    <td class="td" v-else-if="produto.marca_nome !== null">
                      {{ produto.marca_nome }}
                    </td>
                    <td class="td" v-else>Sem Marca</td>
                    <td class="td">
                      <span class="ml-4">{{ produto.quantidade }}</span>
                    </td>
                    <td class="td" v-if="produto.medida !== null">
                      {{ produto.medida.nome }}
                    </td>
                    <td class="td" v-else-if="produto.medida_nome">
                      {{ produto.medida_nome }}
                    </td>
                    <td class="td" v-else>Sem Medida</td>
                    <td class="td">
                      <div v-if="produto.foto !== null">
                        <img
                          class="img-small"
                          :src="`${getImagesAddress}` + produto.foto"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="cc-content">
            <!-- Campo de arquivo -->
            <div class="row m-0" v-if="cotacao[0].arquivo !== null">
              <div class="col-12 p-0 m-15px-0px">
                <div
                  class="d-inline-block"
                  v-if="cotacao[0].quantidade_arquivo !== null"
                >
                  Quantidade: {{ cotacao[0].quantidade_arquivo }}
                </div>
                <div
                  class="d-inline-block m-l-20px"
                  v-if="cotacao[0].arquivo !== null"
                >
                  <a
                    :href="`${getImagesAddress}` + cotacao[0].arquivo"
                    class="btn btn-primary c-pointer fs-14 text-uppercase bg-dark-blue"
                    download
                  >
                    Baixar arquivo
                    <i class="fas fa-file-upload m-l-7px"></i>
                  </a>
                </div>
              </div>
            </div>
            <!-- Campo de imagem -->
            <div class="row m-0" v-if="cotacao[0].imagem !== null">
              <div class="col-12 p-0 m-15px-0px">
                <div
                  class="d-inline-block"
                  v-if="cotacao[0].quantidade_foto !== null"
                >
                  Quantidade: {{ cotacao[0].quantidade_foto }}
                </div>
                <DownloadImages :allImages="this.cotacao[0].imagem" />
              </div>
            </div>
          </div>
          <div class="cc-content">
            <div class="row m-0">
              <div
                class="col-4 p-0-left"
                v-if="checkIsEmpty(this.cotacao[0].cep)"
              >
                <b class="font-weight-bold text-uppercase fs-14"
                  >Retira na loja</b
                >
              </div>
              <div class="col-4 p-0" v-else>
                <b class="font-weight-bold text-uppercase fs-14"
                  >CEP de entrega: {{ this.cotacao[0].cep }}</b
                >
              </div>
            </div>
          </div>
          <div class="cc-footer text-right">
            <div class="btn-voltar" @click="voltarCotacao()">Voltar</div>
          </div>
        </div>
        <div class="mt-2 jumbotron text-center p-3">
          <p class="fs-14">
            Ainda não recebeu uma resposta para seu orçamento? Nos envie uma
            mensagem para agilizarmos o processo!
          </p>
          <a
            target="_blank"
            rel="noopener noreferrer"
            class="btn btn-sm btn-success fs-16 mt-2"
            :href="`https://api.whatsapp.com/send?phone=5519992065613&text=${this.textForWhatsapp}&source=&data=&app_absent=`"
          >
            <i class="fab fa-whatsapp mr-2"></i>
            Enviar Mensagem
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import DownloadImages from '../../components/DownloadImages.vue';

export default {
  name: 'cotacao',
  components: {
    DownloadImages,
  },
  props: ['id'],
  created() {
    const self = this;

    if (this.checkIsEmpty(this.dadosUsuario)) {
      this.$router.push({ name: 'area-restrita' });
    }

    this.$store.dispatch('emptyCotacao').then(() => {
      this.$store.dispatch('startLoader');
      setTimeout(() => {
        self.$store
          .dispatch('showCotacao', this.id)
          .then(() => {
            setTimeout(() => {
              self.$store.dispatch('endLoader');
            }, 1000);
          })
          .catch(() => {
            setTimeout(() => {
              self.$store
                .dispatch('showCotacao', this.id)
                .then(() => {
                  setTimeout(() => {
                    self.$store.dispatch('endLoader');
                  }, 1000);
                })
                .catch(() => {
                  self.$store.dispatch('endLoader');
                  self.aviso(
                    'Não foi possível carregar as cotações! Tente novamente em 5 minutos!',
                    'danger'
                  );
                });
            }, 1000);
          });
      }, 1000);
    });
  },
  computed: {
    ...mapGetters('general', ['getImagesAddress']),
    textForWhatsapp() {
      return `Olá, ainda não recebi nenhuma resposta para o orçamento ${this.cotacao[0].id}, gostaria que vocês pudessem acelerar esse processo.`;
    },
    ...mapState({
      dadosUsuario: (state) => state.dadosUsuario,
      cotacao: (state) => state.cotacao,
    }),
    produtos() {
      const { produtos } = this.cotacao[0];
      return produtos;
    },
    preferencia() {
      const pref = this.cotacao[0].preferencia;
      if (pref == 1) {
        return 'Menor Preço';
      }
      if (pref == 2) {
        return 'Custo-Benefício';
      }
      if (pref == 3) {
        return 'Melhor Marca';
      }
    },
    cep() {
      const { cep } = this.cotacao[0];
      if (!this.checkIsEmpty(this.cotacao[0].cep)) {
        if (cep.length <= 8) {
          return cep;
        }
        return 'CEP invalido';
      }
      return 'Retira na loja';
    },
  },
  methods: {
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    voltarCotacao() {
      this.$router.push({
        name: 'cliente-solicitados',
      });
    },
  },
};
</script>
